import React, { useMemo, useState } from "react";
import { compose } from "redux";
import {
  withStyles,
  withBreakpoint,
  withMobile,
  Text
} from "components/common";
import Table from "components/common/Table";
import TableFilter from "components/common/TableFilter";

const moment = require("moment");

const mapping = {};
const tableFilter = () => (
  <div className="flex justify-start">
    <h1 className="flex-initial">Referrals</h1>
    <TableFilter
      mapping={mapping}
      containerClassName="flex-initial font-light ml-8 self-center text-gray-primary"
      initialActive="All"
    />
  </div>
);

const computeColumns = belowMd =>
  belowMd
    ? [
        {
          Header: "Name",
          accessor: "name"
        },
        {
          Header: "Status",
          accessor: data => (
            <div className="flex flex-col">
              <Text>
                {data.ended_at && data.status.toLowerCase() !== "expired"
                  ? `${moment().to(moment.unix(data.ended_at), true)} left`
                  : ""}
              </Text>
              <Text>
                {data.status.toLowerCase() !== "settled" ? data.status : null}
              </Text>
            </div>
          )
        }
      ]
    : [
        {
          Header: tableFilter,
          accessor: "name"
        },
        {
          Header: "Status",
          accessor: "status"
        },
        {
          Header: "Sign up date",
          accessor: "started_at",
          Cell: ({ value }) =>
            value ? moment.unix(value).format("M/D/YYYY") : "N/A"
        },
        {
          Header: "Time left",
          accessor: data =>
            data.ended_at && data.status.toLowerCase() !== "expired"
              ? data.ended_at
              : undefined,
          Cell: ({ value }) =>
            value === undefined ? "N/A" : moment().to(moment.unix(value), true)
        }
      ];

const ReferralsTable = ({ referrals = [], breakpointContext: { isBelow } }) => {
  const columns = useMemo(() => computeColumns(isBelow("md")), [isBelow]);
  const [filteredReferrals, setFilteredReferrals] = useState(referrals);
  const activeReferrals = referrals.filter(ref => ref.status === "active");
  const expiredReferrals = referrals.filter(ref => ref.status === "expired");
  mapping.all = {
    name: "All",
    fn: () => setFilteredReferrals(referrals)
  };
  mapping.active = {
    name: `Active (${activeReferrals.length})`,
    fn: () => setFilteredReferrals(activeReferrals)
  };
  mapping.expired = {
    name: `Expired (${expiredReferrals.length})`,
    fn: () => setFilteredReferrals(expiredReferrals)
  };

  return (
    <div className="mt-16">
      <div className="my-6">
        <Table
          id="referrals-table"
          data={filteredReferrals}
          columns={columns}
          emptyStateText="You currently have no referrals."
        />
        <div className="mt-6 pl-2">
          <p>
            <span className="font-bold">Please note: </span>
            it can take 1-2 weeks for approved referrals to display in your
            dashboard
          </p>
        </div>
      </div>
    </div>
  );
};

export default compose(withMobile, withStyles, withBreakpoint)(ReferralsTable);
